import axios from "axios";
import relationPcas from "../../models/pcas/relationPcas";
import pcas from "../../models/pcas/pcas";
import roles from "../../models/pcas/roles";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getPcasRelations() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/pcasroles`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return relationPcas.fromJson(item);
      });
    });
  }
  getPcas() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/pcas`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return pcas.fromJson(item);
      });
    });
  }
  getRoles() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/roles`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return roles.fromJson(item);
      });
    });
  }

  addRelation(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.post(`${url}/pcasroles`, data, { headers });
  }

  deleteRelation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/pcasroles/${data.pcaid}&${data.rolid}`, {
      headers,
    });
  }
}
export default service;
